module.exports = __webpack_public_path__ + "r-v3/img/zoom_fit.3fe09e65.svg";